<script>
import options from './RolesFormContent.options'
export default options
</script>

<template>
  <article class="kb-stafet-donation-flow kb-roles-form-content">
    <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">

      <ActiveRolesList />
      <hr role="presentation" class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller" />

      <RequestRole />
      <hr role="presentation" class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller" />

    </section>
  </article>
</template>
